import React from 'react'

import './inputs.css'

const Label = (props) => {
	return (
		<p className="label">{props.label}</p>
	)
}

const Component = (props) => {
	const classnames = `field input-text ${props.className}`
  return (
  	<div className="input-group">
  		{ props.label && <Label {...props} /> }
			<input 
				{...props}
				className={classnames} />
		</div>
  )
}
export default Component
